import gql from "graphql-tag";

const getAllBranchLocation = gql`
  query($query: String, $limit: Int, $page: Int) {
    getAllBranchLocation(
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      id
      name
      updatedAt
      createdAt
    }
  }
`;

export default { getAllBranchLocation };
